import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import './assign-confirmation-row.scss';

interface AssignConfirmationRowProps {
  serviceRequest: IServiceRequest;
}

const AssignConfirmationRow = ({
  serviceRequest,
}: AssignConfirmationRowProps) => {
  const ticketNumber: string =
    serviceRequest.ticketNumber ?? serviceRequest.number ?? '—';
  const subject: string = serviceRequest.subject?.trim() || 'No subject';
  const propertyName: string = serviceRequest.propertyName ?? '';
  const currentAssignee: string | null =
    serviceRequest.serviceProviderFullName;

  return (
    <div className="assign-confirmation-row">
      <div className="assign-confirmation-row-identity">
        <div className="assign-confirmation-row-number">{ticketNumber}</div>
        <div className="assign-confirmation-row-subject">{subject}</div>
      </div>

      <div className="assign-confirmation-row-property">{propertyName}</div>

      <div className="assign-confirmation-row-assignee">
        {currentAssignee ? (
          <CategoryPill
            text={currentAssignee}
            color="var(--color-status-negative)"
            textColor="#fff"
            size="small"
          />
        ) : (
          <CategoryPill text="Unassigned" size="small" />
        )}
      </div>
    </div>
  );
};

export default AssignConfirmationRow;